import React from 'react';
import { Alert, AlertIcon, AlertTitle, Button, Flex } from '@chakra-ui/react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';

interface Props {
  onRetry: () => void;
  isRetrying: boolean;
  retryLimitReached?: boolean;
  compact?: boolean;
}

export function ScheduledChargesError({
  onRetry,
  isRetrying,
  retryLimitReached = false,
  compact = false,
}: Props) {
  const { tSystem } = useSystemTranslation();

  return (
    <Alert
      status="error"
      variant="subtle"
      alignItems="center"
      borderRadius="md"
      bg="red.100"
      color="red.800"
      maxW={compact ? 'full' : '640px'}
      mx={compact ? 0 : 'auto'}
      px={4}
      py={2}
      mb={compact ? 2 : 0}
    >
      <AlertIcon boxSize={4} color="red.800" mr={2} />
      <Flex align="center" wrap="wrap" columnGap={2}>
        <AlertTitle fontSize="13px" fontWeight="600" lineHeight="20px" mb={0}>
          {tSystem(SystemTranslationKeys.common.failedToLoadCharges)}
        </AlertTitle>
        {!retryLimitReached && (
          <Button
            size="sm"
            variant="link"
            color="red.800"
            textDecoration="underline"
            fontSize="13px"
            px={0}
            onClick={onRetry}
            isDisabled={isRetrying}
          >
            {tSystem(SystemTranslationKeys.common.tryAgain)}
          </Button>
        )}
      </Flex>
    </Alert>
  );
}
